import { useFormContext } from 'react-hook-form';
import { BoloPanelFormType } from '@mark43/cad-api';
import { Divider, useEditableMode, VStack, EditableGroup } from '@cad-arc';
import React, { useEffect } from 'react';
import { useBootstrapState } from '../../../bootstrap/bootstrap-provider';
import { FormBody } from '../../../forms/integrated-form-components/form-body';
import { BoloFormInformationFields } from './bolo-form-information-fields';
import { BoloFormRecipientFields } from './bolo-form-recipient-fields';
import { BoloPanelFormPersonsFields } from './bolo-panel-form-persons-fields';
import { BoloPanelFormVehiclesFields } from './bolo-panel-form-vehicles-fields';
import { useBoloPanelMetadata } from '../state/bolo-panel-metadata-context';
import { observer } from 'mobx-react-lite';

export const BoloPanelFormBody = observer(() => {
    const form = useFormContext<BoloPanelFormType>();
    const { boloPanelOptions, eventPanelOptions } = useBootstrapState();
    const [editableMode, setEditableMode] = useEditableMode('edit');
    const metadata = useBoloPanelMetadata();
    const isActive = metadata?.isActive;

    useEffect(
        function updateEditableMode() {
            if (isActive) {
                setEditableMode('view');
            }
        },
        // a bug in useEditableMode means we can't use it as a dependency
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [isActive]
    );

    return (
        <FormBody formBodyStyle={{ width: '100%' }}>
            <VStack w="100%" alignItems="flex-start" spacing={4}>
                <EditableGroup mode={editableMode}>
                    <BoloFormInformationFields
                        form={form}
                        boloPanelOptions={boloPanelOptions}
                        editableMode={editableMode}
                    />
                    <Divider />
                    <BoloFormRecipientFields form={form} />
                    {!isActive && (
                        <>
                            <Divider />
                            <BoloPanelFormPersonsFields
                                form={form}
                                eventPanelOptions={eventPanelOptions!}
                                isClearedBolo={false}
                                allowMembersControl
                            />
                            <Divider />
                            <BoloPanelFormVehiclesFields
                                form={form}
                                eventPanelOptions={eventPanelOptions!}
                                isClearedBolo={false}
                                allowMembersControl
                                isNewBolo={true}
                            />
                        </>
                    )}
                </EditableGroup>
            </VStack>
        </FormBody>
    );
});
